import { useState, useEffect } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ProductList } from '@/components/products/ProductList';
import { ProductPlansList } from '@/components/products/ProductPlansList';
import { Package, CreditCard } from 'lucide-react';

export default function Products() {
  const [activeTab, setActiveTab] = useState('products');

  useEffect(() => {
    document.title = 'Dashi | Produtos';
  }, []);

  return (
    <div className="container mx-auto py-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold flex items-center gap-2">
            <Package className="h-8 w-8" />
            Gestão de Produtos
          </h1>
          <p className="text-muted-foreground mt-1">
            Gerencie seus produtos e planos de assinatura
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="products" className="flex items-center gap-2">
            <Package className="h-4 w-4" />
            Meus Produtos
          </TabsTrigger>
          <TabsTrigger value="plans" className="flex items-center gap-2">
            <CreditCard className="h-4 w-4" />
            Planos
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="products">
          <Card>
            <CardHeader>
              <CardTitle>Meus Produtos</CardTitle>
              <CardDescription>Lista de produtos cadastrados</CardDescription>
            </CardHeader>
            <CardContent>
              <ProductList />
            </CardContent>
          </Card>
        </TabsContent>
        
        <TabsContent value="plans">
          <Card>
            <CardHeader>
              <CardTitle>Planos de Assinatura</CardTitle>
              <CardDescription>Gerencie os planos dos seus produtos</CardDescription>
            </CardHeader>
            <CardContent>
              <ProductPlansList />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
